import { memo } from 'react';
import Dashboard from '../../../app/main/dashboard/dashboard';

function DemoContent() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default memo(DemoContent);
